/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Destination } from './Destination';
import {
    DestinationFromJSON,
    DestinationFromJSONTyped,
    DestinationToJSON,
} from './Destination';
import type { ERP } from './ERP';
import {
    ERPFromJSON,
    ERPFromJSONTyped,
    ERPToJSON,
} from './ERP';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './Source';

/**
 * 
 * @export
 * @interface TrackPost
 */
export interface TrackPost {
    /**
     * 
     * @type {Source}
     * @memberof TrackPost
     */
    source?: Source;
    /**
     * 
     * @type {Destination}
     * @memberof TrackPost
     */
    destination?: Destination;
    /**
     * 
     * @type {ERP}
     * @memberof TrackPost
     */
    erp?: ERP;
    /**
     * Expected Time of Arrival as indicated by the user.
     * @type {string}
     * @memberof TrackPost
     */
    eta?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackPost
     */
    id?: string;
}

/**
 * Check if a given object implements the TrackPost interface.
 */
export function instanceOfTrackPost(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TrackPostFromJSON(json: any): TrackPost {
    return TrackPostFromJSONTyped(json, false);
}

export function TrackPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackPost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source': !exists(json, 'source') ? undefined : SourceFromJSON(json['source']),
        'destination': !exists(json, 'destination') ? undefined : DestinationFromJSON(json['destination']),
        'erp': !exists(json, 'erp') ? undefined : ERPFromJSON(json['erp']),
        'eta': !exists(json, 'eta') ? undefined : json['eta'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function TrackPostToJSON(value?: TrackPost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source': SourceToJSON(value.source),
        'destination': DestinationToJSON(value.destination),
        'erp': ERPToJSON(value.erp),
        'eta': value.eta,
        'id': value.id,
    };
}

